import { createAction, props } from '@ngrx/store';
import { Tramite } from './tramite.models';

export const tramiteCreate = createAction('[Tramite] Create');
export const tramiteGet = createAction('[Tramite] Get');
export const tramiteDelete = createAction('[Tramite] Delete');

export const tramiteCreateRequest = createAction('[Tramite] Create Request', props<Tramite>());
export const tramiteCreateFailure = createAction('[Tramite] Create Failure', props<{ error: string }>());
export const tramiteCreateSuccess = createAction('[Tramite] Create Success', props<{ tramite: Tramite }>());

export const tramiteDeleteRequest = createAction('[Tramite] Delete Request');
export const tramiteDeleteFailure = createAction('[Tramite] Delete Failure', props<{ error: string }>());
export const tramiteDeleteSuccess = createAction('[Tramite] Delete Success');

export const tramiteGetRequest = createAction('[Tramite] Get Request');
export const tramiteGetFailure = createAction('[Tramite] Get Failure', props<{ error: string }>());
export const tramiteGetSuccess = createAction('[Tramite] Get Success', props<{ items: Tramite[] }>());
